import * as tslib_1 from "tslib";
import { MatDialog, MatDialogRef, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
import * as i2 from "@angular/material/snack-bar";
// #region Splash Dialog Component
var SplashDialogComponent = /** @class */ (function () {
    function SplashDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.title = data.TitleText;
        this.message = data.MessageText;
        this.showProgress = data.ShowProgressBar;
    }
    return SplashDialogComponent;
}());
export { SplashDialogComponent };
// #endregion
var BaseSplashOptions = /** @class */ (function () {
    function BaseSplashOptions() {
    }
    return BaseSplashOptions;
}());
export { BaseSplashOptions };
export { BaseSplashOptions as SplashOptions };
var SplashService = /** @class */ (function () {
    function SplashService(dialog, snackbar) {
        this.dialog = dialog;
        this.snackbar = snackbar;
    }
    // #region Close Splash Method
    SplashService.prototype.CloseSplash = function () {
        if (this.openHandle) {
            this.openHandle.close();
        }
        this.openHandle = null;
    };
    // #endregion
    // #region Open Splash Method
    SplashService.prototype.OpenSplash = function (options) {
        this.openHandle = this.dialog.open(SplashDialogComponent, {
            disableClose: true,
            data: tslib_1.__assign({ TitleText: 'Please wait', MessageText: 'Loading...', ShowProgressBar: true }, options),
        });
        return this.openHandle.afterOpen();
    };
    // #endregion
    // #region Snackbar Alert Method
    SplashService.prototype.SnackbarAlert = function (message, duration) {
        var config = {
            panelClass: ['alert'],
        };
        config.duration = duration != null ? duration : 3500;
        return this.snackbar.open(message, null, config);
    };
    // #endregion
    // #region Snackbar Error Method
    SplashService.prototype.SnackbarError = function (message, duration, hold) {
        var config = {
            panelClass: ['error'],
        };
        var action = null;
        if (duration != null) {
            config.duration = duration;
        }
        if (hold === true) {
            action = 'OK';
            config.duration = 5 * 60 * 1000; // 5 minutes?
        }
        return this.snackbar.open(message, action, config);
    };
    // #endregion
    // #region Snackbar Success Method
    SplashService.prototype.SnackbarSuccess = function (message, duration) {
        var config = {
            panelClass: ['success'],
        };
        config.duration = duration || 3500;
        return this.snackbar.open(message, null, config);
    };
    SplashService.ngInjectableDef = i0.defineInjectable({ factory: function SplashService_Factory() { return new SplashService(i0.inject(i1.MatDialog), i0.inject(i2.MatSnackBar)); }, token: SplashService, providedIn: "root" });
    return SplashService;
}());
export { SplashService };
